var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'pp-ui-button': _vm.applyStyles, 'pp-ui-button-play': _vm.applyStyles},on:{"click":function($event){_vm.player.fullscreen = !_vm.player.fullscreen}}},[_vm._t("default",function(){return [(!_vm.player.fullscreen)?_c('IconEnter'):_c('IconExit')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }